import { Components, Theme } from "@mui/material";

export const MuiPaper: Components<Theme>["MuiPaper"] = {
  styleOverrides: {
    rounded: {
      borderRadius: "4px",
    },
    elevation4: {
      boxShadow: "none",
    },
  },
};
